import { Progress as MantineProgress, ProgressProps, useMantineTheme } from '@mantine/core';
import { forwardRef } from 'react';
import { usePreferencesStore } from '../../../stores';
import { LINE_HEIGHT_MAP, LETTER_SPACING_MAP } from '../../../hooks/useAccessibilityStyles';

export type GradientVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger';

export interface ThemedProgressProps extends ProgressProps {
  gradientVariant?: GradientVariant;
  showValue?: boolean;
}

const Progress = forwardRef<HTMLDivElement, ThemedProgressProps>(
  ({ gradientVariant = 'primary', value, showValue = false, style, ...rest }, ref) => {
    const theme = useMantineTheme();
    const gradient = theme.other.gradients[gradientVariant];
    const lineSpacing = usePreferencesStore((state) => state.lineSpacing);
    const letterSpacingPref = usePreferencesStore((state) => state.letterSpacing);

    const accessibilityStyles = {
      lineHeight: LINE_HEIGHT_MAP[lineSpacing],
      letterSpacing: LETTER_SPACING_MAP[letterSpacingPref],
    };

    return (
      <MantineProgress
        ref={ref}
        value={value}
        style={{
          ...style,
        }}
        styles={{
          section: {
            backgroundImage: `linear-gradient(90deg, ${gradient.from}, ${gradient.to})`,
          },
          label: showValue
            ? {
                color: 'white',
                fontWeight: 600,
                ...accessibilityStyles,
              }
            : undefined,
        }}
        {...rest}
      >
        {showValue && `${value}%`}
      </MantineProgress>
    );
  }
);

Progress.displayName = 'Progress';

export default Progress;
